import React, { FC } from 'react';
import { Box, DialogActions, DialogContent, Grid } from '@material-ui/core';
import classNames from 'classnames';
import DialogWithCloseButton from '../../components/DialogWithCloseButton/DialogWithCloseButton';
import { UploadcareFile } from '../../types/uploadcare/file';
import ResponsiveImage from '../../components/ResponsiveImage/ResponsiveImage';
import { formatUploadcareImageForDisplay } from '../../util/uploadcare';
import Button from '../../components/Button/Button';

import css from './ChooseCoverPhotoModal.module.css';
import { Divider, IconCheckCircleFilled, TypographyWrapper } from '../../components';
import IconLightBulb from '../../components/Icons/IconLightBulb/IconLightBulb';

interface ChooseCoverPhotoModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
  images: UploadcareFile[];
  onCoverPhotoSelected: (image: UploadcareFile) => void;
  selectedImageUuid?: string;
  modalHelperText?: string;
}

const ChooseCoverPhotoModal: FC<ChooseCoverPhotoModalProps> = (
  props: ChooseCoverPhotoModalProps
) => {
  const {
    isOpen,
    onClose,
    onSubmit,
    images,
    onCoverPhotoSelected,
    selectedImageUuid,
    modalHelperText,
  } = props;

  return (
    <DialogWithCloseButton open={isOpen} onClose={onClose} titleText="Choose Cover Photo">
      <Divider className={css.divider} />
      {images.length && (
        <>
          <DialogContent
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-start',
            }}
          >
            {modalHelperText && (
              <Box py={1} my={2} display="flex" alignItems="center">
                <IconLightBulb className={css.iconLightBulb} />
                <TypographyWrapper
                  variant="body1"
                  typographyOverrides={{ style: { paddingTop: '5px' } }}
                >
                  {modalHelperText}
                </TypographyWrapper>
              </Box>
            )}
            <Grid container spacing={3} style={{ margin: 0, width: '100%' }}>
              {images.map((image: UploadcareFile) => {
                const isSelected = image.uuid === selectedImageUuid;
                return (
                  <Grid
                    item
                    key={image.uuid}
                    xs={6}
                    className={classNames(css.threeToTwoWrapper, {
                      [css.selectedProductImage]: isSelected,
                    })}
                  >
                    <button
                      className={css.coverPhotoTextButton}
                      type="button"
                      onClick={() => onCoverPhotoSelected(image)}
                    >
                      <ResponsiveImage
                        src={formatUploadcareImageForDisplay(image.cdnUrl)}
                        alt={image.name}
                      />
                    </button>
                    {isSelected && <IconCheckCircleFilled className={css.selectedCheckMark} />}
                  </Grid>
                );
              })}
            </Grid>
          </DialogContent>
          <Divider className={css.divider} />
          <DialogActions>
            <Box display="flex" justifyContent="flex-end" p={1}>
              <Button onClick={onSubmit}>Next</Button>
            </Box>
          </DialogActions>
        </>
      )}
    </DialogWithCloseButton>
  );
};

export default ChooseCoverPhotoModal;
